// E.A.T. IdeaToImpact: shared page configuration.

// Applications are taken on the website itself (synopsis upload, team and contact details).
export const APPLY_PATH = '/ideatoimpact/apply';

// Last day to apply for the first cohort: the end of the day, India Standard Time.
// The API enforces the same date (IdeaToImpact:ClosingDate), so keep the two in step.
export const CLOSING_DATE = new Date('2026-11-30T23:59:59+05:30');
export const CLOSING_DATE_LABEL = '30 November 2026';
export const isApplicationOpen = (now = new Date()) => now <= CLOSING_DATE;

// The date above is only the fallback. An admin can change the last date (Admin > IdeaToImpact),
// and the pages read the saved value from the API (see hooks/useApplicationWindow.js).
const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// '2026-11-30' -> '30 November 2026'. Returns '' for anything that is not a yyyy-MM-dd date.
export function formatClosingDate(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
  if (!m) return '';
  const month = MONTHS[Number(m[2]) - 1];
  return month ? `${Number(m[3])} ${month} ${m[1]}` : '';
}

// Link preview card for the IdeaToImpact pages (public/og-ideatoimpact.png, 1200x630).
export const OG_IMAGE = 'https://eattechpl.com/og-ideatoimpact.png';
export const OG_IMAGE_ALT = 'E.A.T. IdeaToImpact: project sponsorship and problem-solving program';

export const CONTACT = {
  phoneDisplay: '+91 8867799701',
  phoneHref: 'tel:+918867799701',
  email: 'furqan.mestri@eattechpl.com',
  websiteDisplay: 'eattechpl.com',
  websiteHref: 'https://eattechpl.com',
  location: 'Belgaum, Karnataka, India',
};

// Values the backend validates against. Keep in sync with IdeaApplicationValues / the DTO.
export const COURSES = ['BCA', 'MCA', 'B.E.', 'B.Sc.'];
export const STAGES = ['Final-year student', 'PSP / project proposal stage'];
export const MAX_SYNOPSIS_BYTES = 5 * 1024 * 1024;
